import React from "react";
import OrderTable from "../Table";

const CreatingInvoice = () => {
  return <OrderTable type="Creating Invoice" />;
};

export default CreatingInvoice;
